import { Box, Typography, Chip, CircularProgress } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { colors, cardSx } from '../theme/designTheme';

const fmtAmount = (n) => (n == null ? '—' : `$${Number(n).toLocaleString()}`);

const DepositTraceCard = ({ trace, isLoading }) => {
  const hops = trace?.hops ?? [];

  return (
    <Box sx={{ ...cardSx, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderBottom: `1px solid ${colors.borderSubtle}`, flexShrink: 0 }}>
        <Typography sx={{ color: colors.textPrimary, fontFamily: 'Lexend', fontWeight: 700, fontSize: '13px' }}>
          Fund Flow Analysis
        </Typography>
        {trace?.deposit_amount != null && (
          <Typography sx={{ color: colors.accent, fontFamily: 'Lexend', fontSize: '12px', fontWeight: 700 }}>
            {fmtAmount(trace.deposit_amount)}
          </Typography>
        )}
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2 }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={20} sx={{ color: colors.accent }} />
          </Box>
        ) : hops.length === 0 ? (
          <Typography sx={{ color: colors.textMuted, fontFamily: 'Lexend', fontSize: '12px', textAlign: 'center', py: 2 }}>
            No fund movements recorded.
          </Typography>
        ) : (
          <Box>
            {/* Subject (destination) */}
            {trace?.destination_entity && (
              <Box sx={{
                p: 1.25, borderRadius: 1, bgcolor: colors.accentDim,
                border: `1px solid ${colors.accent}`, mb: 0.75,
              }}>
                <Typography sx={{ color: colors.accent, fontFamily: 'Lexend', fontSize: '9px', fontWeight: 700, letterSpacing: '0.08em' }}>
                  SUBJECT
                </Typography>
                <Typography sx={{ color: colors.textPrimary, fontFamily: 'Lexend', fontSize: '12px', fontWeight: 600 }}>
                  {trace.destination_entity}
                </Typography>
              </Box>
            )}

            {hops.map((h, i) => (
              <Box key={h.hop_index} sx={{ position: 'relative' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <ArrowDownwardIcon sx={{ color: colors.medium, fontSize: 16 }} />
                    <Typography sx={{ color: colors.medium, fontFamily: 'Lexend', fontSize: '11px', fontWeight: 700 }}>
                      {fmtAmount(h.amount)}
                    </Typography>
                    {h.occurred_at && (
                      <Typography sx={{ color: colors.textMuted, fontFamily: 'Lexend', fontSize: '10px' }}>
                        · {h.occurred_at}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Box sx={{
                  p: 1.25, borderRadius: 1,
                  bgcolor: colors.surfaceElevated,
                  border: `1px solid ${colors.borderSubtle}`,
                  mb: 0.75,
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 0.4 }}>
                    <Typography sx={{ color: colors.textMuted, fontFamily: 'Lexend', fontSize: '9px', fontWeight: 700, letterSpacing: '0.08em' }}>
                      HOP {h.hop_index} ORIGIN
                    </Typography>
                    {h.related_case && (
                      <Chip
                        size="small"
                        label={`REF-${h.related_case}`}
                        sx={{
                          bgcolor: colors.criticalBg, color: colors.critical,
                          border: `1px solid ${colors.criticalBorder}`,
                          borderRadius: '3px', fontFamily: 'Lexend',
                          fontSize: '9px', fontWeight: 700, height: 18,
                        }}
                      />
                    )}
                  </Box>
                  <Typography sx={{ color: colors.textPrimary, fontFamily: 'Lexend', fontSize: '12px', fontWeight: 600 }}>
                    {h.from_entity}
                  </Typography>
                  {h.notes && (
                    <Typography sx={{ color: colors.textSecondary, fontFamily: 'Lexend', fontSize: '11px', mt: 0.5, lineHeight: 1.4 }}>
                      {h.notes}
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DepositTraceCard;
